// NOTE: this file wasn't shared in the conversation — recreated here with a
// shape matching MachineCard's fields, seeded from the machines visible in
// your screenshot. Replace with your real data source if this already exists
// in your project.
const machines = [
  {
    code: "M-3DP-01",
    name: "Industrial FDM 3D Printer",
    technology: "3D Printing",
    make: "Stratasys F770",
    centre: "Visakhapatnam",
    hourlyRate: 850,
    status: "Available",
  },
  {
    code: "M-PCB-03",
    name: "PCB Prototyping Machine",
    technology: "PCB",
    make: "LPKF ProtoMat S104",
    centre: "Visakhapatnam",
    hourlyRate: 1100,
    status: "Maintenance",
  },
  {
    code: "M-CNC-02",
    name: "5-Axis CNC Mill",
    technology: "CNC",
    make: "Haas UMC-750",
    centre: "Vijayawada",
    hourlyRate: 1450,
    status: "Available",
  },
  {
    code: "M-LSR-01",
    name: "Fiber Laser Cutter",
    technology: "Laser Cutting",
    make: "Trumpf TruLaser 3030",
    centre: "Vijayawada",
    hourlyRate: 950,
    status: "Booked",
  },
  {
    code: "M-MLD-01",
    name: "Injection Moulding Press",
    technology: "Moulding",
    make: "Arburg Allrounder 470",
    centre: "Tirupati",
    hourlyRate: 1600,
    status: "Available",
  },
  {
    code: "M-ROB-01",
    name: "6-Axis Robotic Arm Cell",
    technology: "Robotics",
    make: "KUKA KR 10",
    centre: "Kurnool",
    hourlyRate: 1200,
    status: "Running",
  },
];

export default machines;